<template>
  <div class="header">
    <el-row type="flex" align="middle">
      <el-col id="header-logo" :md="4" :xs="4">
        <img src="https://g-lab.xyz/images/og_image.png" alt="车库Lab-分享最新最特别的小技能" height="28" id="normal-logo">
        <img src="https://g-lab.xyz/images/favicon.ico" alt="车库Lab-分享最新最特别的小技能" height="28" id="small-logo">
      </el-col>
      <el-col class="navbar navbar-start" :md="4">
        <el-menu :default-active="this.$route.path.substr(1)" mode="horizontal" @select="handleSelect" active-text-color="#909399">
          <el-menu-item index="home">{{ $t('navbar.home') }}</el-menu-item>
          <el-menu-item index="blog">{{ $t('navbar.blog') }}</el-menu-item>
        </el-menu>
      </el-col>
      <el-col class="navbar navbar-end" :md="{span: 16}" :xs="{span:16}">
        <el-dropdown @command="handleSelectLanguage">
          <span class="el-dropdown-link">
            {{ $t('navbar.language') }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="cn">中文</el-dropdown-item>
            <el-dropdown-item command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    handleSelect(key) {
      if (key === 'blog') {
        window.location.href = 'https://g-lab.xyz'
      } else {
        this.$router.push({ name: 'index' })
      }
    },
    handleSelectLanguage(command) {
      this.$i18n.locale = command
      localStorage.lang = command
    }
  }
}
</script>

<style scoped>
.header {
  border-bottom: 1px solid #dcdfe6;
}
#header-logo{
  padding-left: 2.5em;
}
.el-menu, .is-active {
  border-bottom-width: 0px;
}
.el-menu-item:not(.is-disabled):hover {
  color: #409EFF;
}
.el-menu-item.is-active {
  border-bottom-width: 0px;
}
.el-dropdown-link {
  cursor: pointer;
  color:rgb(144, 147, 153);
}
.el-icon-arrow-down {
  font-size: 12px;
}
#small-logo {
  display: none;
}
.navbar-end {
  text-align: right;
  padding-right: 10em; 
}
@media screen and (max-width: 767px) {
  #small-logo {
    display: inline;
  }
  #normal-logo {
    display: none;
  }
  #header-logo{
    padding-left: 0;
  }
  .navbar-end {
    padding-right: 0; 
  }
}
</style>